<template>
  <div class="BigBtn">
    <div class="btnWrapper">
      <a 
        target="_blank" 
        :href="btnHref"
        :style="btnStyle">{{btnText}}</a>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'BigBtn',
    data(){
      return {
      }
    },
    components:{
    },
    props: {
      btnHref: {
        type: String,
        default: ""
      },
      btnText: {
        type: String,
        default: ""
      },
      color: {
        type: String,
        default: "#000"
      }
    },
    computed: {
      btnStyle(){
        return{
          backgroundColor: this.color
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  @import (reference) '~@less/_variables';
  .BigBtn{
    font-size: 1rem;
    a:link, a:visited, a:hover, a:active{
      display: block;
      text-decoration: none;
      box-shadow: 0px 8px 30px 0px rgba(0,0,0,0.3);
      color: #fff;
      line-height: 32px;
      font-size: 24px;
      background-image: url(../../img/arrow_right.svg);
      background-position: 97% center;
      background-repeat: no-repeat;
      line-height: 1.5;
      font-size: 1em;
      font-weight: @bold;
      text-align: left;
      padding: 30px 15px;

      @media (min-width: @bootstrap-md){
        line-height: 80px;
        padding: 0 0 0 30px;
      }
    }
  }
</style>
